module.exports = __webpack_public_path__ + "img/cafe.ecba1844.gif";